module.exports = __webpack_public_path__ + "static/media/web-development.7689df57.png";